import { IHeaderColumn } from 'Components/TableBase/SortableTableHead';

export enum EPlotsTableColumnKeys {
  TITLE = 'title',
  CREATED_TIMESTAMP = 'createdTimestamp',
  ACTIONS = 'actions',
}

export const plotsHeaderColumns: IHeaderColumn<EPlotsTableColumnKeys>[] = [
  { id: EPlotsTableColumnKeys.TITLE, headerName: 'Title', sortable: false },
  { id: EPlotsTableColumnKeys.CREATED_TIMESTAMP, headerName: 'Created at', sortable: true },
  { id: EPlotsTableColumnKeys.ACTIONS, headerName: 'Actions', sortable: false, align: 'right' },
];
